import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import '@/core/lazy_lib/components_use'
import Viser from 'viser-vue'

// ext library
// import MultiTab from '@/components/MultiTab'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import PageLoading from '@/components/PageLoading'
import PermissionHelper from '@/utils/helper/permission'

Vue.use(Viser)
// Vue.use(MultiTab)
Vue.use(PageLoading)
Vue.use(VueStorage, config.storageOptions)
Vue.use(VueDraggableResizable)
Vue.use(PermissionHelper)
